export enum Progress {
    ARTIFACTS_GENERATION_FAILED = "ARTIFACTS_GENERATION_FAILED",
    VISUALIZATION_FAILED = "VISUALIZATION_FAILED",
    VISUALIZATION_WARNING = "VISUALIZATION_WARNING",
    SUCCESS = "SUCCESS",
}
